<template>
	<b-modal
		id="completeSeventy"
		centered
		hide-footer
		hide-header
		v-model="showModal"
		@hidden="resetModal"
		no-close-on-backdrop
	>
		<div class="d-flex flex-column align-items-center gap-3">
			<img src="@/assets/newbuilder/warn-modal-icon.svg" alt="" />
			<div class="fam-lato fw-LM fs-18 text-black text-center">
				Complete at least 70% of your resume to <br />
				become a panelist
			</div>
			<div class="fam-mont fw-LM fs-13 text-344054 text-center">
				Fill your resume and then come back to complete your application! This
				helps us to assess you better.
			</div>
			<b-button class="candash-addBtn my-2" @click="gotoResumeBuilder()"
				>Okay</b-button
			>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: "BecomePanelist",
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	methods: {
		gotoResumeBuilder() {
			this.$router.push({
				name: "CandidateDashboard",
			});
		},
		resetModal() {
			this.$emit("close-modal");
		},
	},
};
</script>

<style></style>
